import Choices from 'choices.js'

window.Choices = Choices
window.initChoicesJs = initChoicesJs

jQuery(window).on('load', function () {
  adjustPageHeader()
  formatCurrency()
  initPhoneInputsFormat()
  initRemainingCharacters()
  initChoicesJs()
})

jQuery(window).on('shown.bs.modal', function () {
  initTooltip()
})

jQuery(document).on('click', "a[data-widget='pushmenu']", function () {
  adjustSidebarCollapsed()
  closeSideBar()
})

function closeSideBar() {
  if (jQuery('body').hasClass('sidebar-collapse')) {
    jQuery('aside.sidebar-focused').removeClass('sidebar-focused')
  }
}

function initRemainingCharacters() {
  jQuery('.has-limit-characters').each(function () {
    updateCharactersRemaining(this)
    jQuery(this).on('input', function () {
      updateCharactersRemaining(this)
    })
    jQuery(this).on('blur', function () {
      updateCharactersRemaining(this)
    })
  })
}

function updateCharactersRemaining(input) {
  const maxLength = jQuery(input).attr('maxlength')
  const currentLength = jQuery(input).val().length
  const remainingLength = maxLength - currentLength
  jQuery(input).next('p.remaining-characters').remove()
  jQuery('.invalid-feedback').next('p.remaining-characters').remove()
  jQuery(input).after(
    "<p class='remaining-characters'>" +
    remainingLength +
    ' ' +
    remainingCharacters.get('remainingCharacters') +
    '</p>'
  )
}

function initPhoneInputsFormat() {
  jQuery('.us_ca_phone').on('input', function (e) {
    let x = jQuery(this)
      .val()
      .replace(/\D/g, '')
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  })
}

function initTooltip() {
  ;[].slice
    .call(document.querySelectorAll('[data-toggle="tooltip"]'))
    ?.map(function (tooltipTriggerEl) {
      return jQuery(tooltipTriggerEl).tooltip()
    })
}

function adjustPageHeader() {
  if (!jQuery('.page-header__options > div').hasClass('button-add-wrapper')) {
    jQuery('.page-header').css({
      'padding-top': '12px',
      'padding-bottom': '12px'
    })
  }
  if (
    jQuery('.button-add-wrapper > a').hasClass('button-refresh') ||
    jQuery('.button-add-wrapper > a').hasClass('button-back')
  ) {
    jQuery('.page-header').css({
      'padding-top': '5px',
      'padding-bottom': '5px'
    })
  }
}

function adjustSidebarCollapsed() {
  if (jQuery('body').hasClass('sidebar-collapse')) {
    jQuery('.nav-header ~ .nav-item:not(.has-treeview) > .nav-link').css('padding', '0.5rem 1rem')
  } else {
    jQuery('.nav-header ~ .nav-item:not(.has-treeview) > .nav-link').css('padding-left', '1.5rem')
  }
}

// From StackOverflow source code
String.prototype.formatUnicorn =
  String.prototype.formatUnicorn ||
  function () {
    'use strict'
    var str = this.toString()
    if (arguments.length) {
      var t = typeof arguments[0]
      var key
      var args =
        'string' === t || 'number' === t ? Array.prototype.slice.call(arguments) : arguments[0]

      for (key in args) {
        str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), args[key])
      }
    }

    return str
  }

function formatCurrency() {
  let currencyClasses = document.getElementsByClassName('currency-value')

  if (currencyClasses) {
    for (let element of currencyClasses) {
      if (isNumericValue(element.innerText)) {
        let newValue = formatValue(parseFloat(element.innerText))
        element.innerText = newValue
      }
    }
  }
}

function formatValue(value) {
  if (value) {
    return value.toLocaleString('fr-CA', 'CAD') + ' $'
  }
}

function isNumericValue(value) {
  return value && !isNaN(parseFloat(value))
}

function initChoicesJs() {
  let options =
    typeof jsChoicesOptions === 'undefined'
      ? new Map([['addItemText', '', 'maxItemText', '']])
      : jsChoicesOptions

  jQuery('.js-choice').each(function () {
    let maxItemCount = -1
    if (jQuery(this).attr('multiple')) {
      if (jQuery(this).attr('max-item-count')) {
        maxItemCount = parseInt(jQuery(this).attr('max-item-count'))
      }
    }

    new Choices(this, {
      maxItemCount: maxItemCount,
      loadingText: options.get('loadingText'),
      noResultsText: options.get('noResultsText'),
      noChoicesText: options.get('noChoicesText'),
      itemSelectText: options.get('itemSelectText'),
      searchResultLimit: 100,
      removeItemButton: jQuery(this).attr('multiple'),
      addItemText: value => {
        return options.get('addItemText').formatUnicorn({
          value: value
        })
      },
      maxItemText: maxItemCount => {
        return options.get('maxItemText').formatUnicorn({
          maxItemCount: maxItemCount
        })
      }
    })
  })
  jQuery('.js-choice--unsorted').each(function () {
    new Choices(this, {
      shouldSort: false,
      loadingText: options.get('loadingText'),
      noResultsText: options.get('noResultsText'),
      noChoicesText: options.get('noChoicesText'),
      itemSelectText: options.get('itemSelectText'),
      searchResultLimit: 100,
      removeItemButton: jQuery(this).attr('multiple'),
      addItemText: value => {
        return options.get('addItemText').formatUnicorn({
          value: value
        })
      },
      maxItemText: maxItemCount => {
        return options.get('maxItemText').formatUnicorn({
          maxItemCount: maxItemCount
        })
      }
    })
  })
}
